@if (showEnrollmentBanner) {
<div class="container px-0 mt-md-4 mt-3">
  <div class="alert alert-warning py-2 px-3 text-md-center mb-0 enrollment-note" role="alert">
    <span [innerHTML]="'wizard.enrollmentNote' | translate"></span>
  </div>
</div>
}
